import React, { useEffect, useState } from 'react';
import './Navbar.css';

const sections = ['home', 'about', 'experience', 'projects', 'showcase', 'contact'];

const Navbar = () => {
  const [activeSection, setActiveSection] = useState('home');
  const [menuOpen, setMenuOpen] = useState(false); // <-- 🔧 This was missing

  useEffect(() => {
    const handleScroll = () => {
      let current = 'home';
      for (let id of sections) {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            current = id;
            break;
          }
        }
      }
      setActiveSection(current);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // initial run

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Desktop Nav */}
      <nav id="desktop-nav">
        <a href="#home" className="logo">Aryan Thakur.</a>
        <div>
          <ul className="nav-links">
            <li>
              <a href="#about" className={activeSection === 'about' ? 'active' : ''}>About</a>
            </li>
            <li>
              <a href="#experience" className={activeSection === 'experience' ? 'active' : ''}>Experience</a>
            </li>
            <li>
              <a href="#projects" className={activeSection === 'projects' ? 'active' : ''}>Projects</a>
            </li>
            <li>
              <a href="#showcase" className={activeSection === 'showcase' ? 'active' : ''}>Showcase</a>
            </li>
            <li>
              <a href="#contact" className={activeSection === 'contact' ? 'active' : ''}>Contact</a>
            </li>
          </ul>
        </div>
      </nav>

      {/* Mobile Nav */}
      <nav id="hamburger-nav">
        <div className="logo">Aryan Thakur.</div>
        <div className="hamburger-menu" onClick={() => setMenuOpen(!menuOpen)}>☰</div>
        <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
          <a href="#home" onClick={() => setMenuOpen(false)}>Home</a>
          <a href="#about" onClick={() => setMenuOpen(false)}>About</a>
          <a href="#experience" onClick={() => setMenuOpen(false)}>Experience</a>
          <a href="#projects" onClick={() => setMenuOpen(false)}>Projects</a>
          <a href="#showcase" onClick={() => setMenuOpen(false)}>Showcase</a>
          <a href="#contact" onClick={() => setMenuOpen(false)}>Contact</a>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
